<template>
 <div class="info">
				<div class="info-base">
					<div class="info-title">基础信息</div>
					<ul class="info-cont info-cont-basic clearfix">
						<li class="info-item">
							<span class="item-name">区块链名称：</span>
							<span class="item-value" style="padding-left:28px;">{{this.extractInfo?'司法联盟链':''}}</span>
						</li>
						<li class="info-item">
							<span class="item-name">存证人：</span>
							<span class="item-value" style="padding-left:14px;">{{this.extractInfo?this.extractInfo.witness:''}}</span>
						</li>
						<li class="info-item">
							<span class="item-name">签发机构：</span>
							<span class="item-value">{{this.extractInfo?'司法联盟链':''}}</span><br>
						</li>
						<li class="info-item">
							<span class="item-name">区块链标识：</span>
							<span class="item-value" style="padding-left:28px;">{{this.extractInfo?'legalXchain':''}}</span>
						</li>
						<li class="info-item">
							<span class="item-name">身份认证:</span>
							<span class="item-value" style="padding-left:8px;">{{this.extractInfo?(this.extractInfo.userRealNameType==1?'个人已实名':'企业已实名'):''}}</span>
						</li>
						<li class="info-item">
							<span class="item-name">签发节点：</span>
							<span class="item-value">{{this.extractInfo?this.extractInfo.partnerName:''}}</span><br>
						</li>
					</ul>
				</div>
				<div class="info-evidence">
					<div class="info-title">证据信息</div>
					<ul class="info-cont info-cont-certificate clearfix">
						<li class="info-item">
							<span class="item-name">证据提取包名称：</span>
							<el-popover
							        v-if="this.extractInfo?this.extractInfo.packageName && this.extractInfo.packageName.length>13:false"
							        style="float: right;margin-right: 67px;"
									placement="top-start"
									width="200"
									trigger="hover"
									:content="this.extractInfo?this.extractInfo.packageName:''">
									<span class="item-value" slot="reference"  style="cursor: pointer;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: inline-block;width: 200px;" >{{this.extractInfo?this.extractInfo.packageName:""}}</span>
							</el-popover>
							<span v-else class="item-value" slot="reference"  style="cursor: pointer;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: inline-block;width: 200px;" >{{this.extractInfo?this.extractInfo.packageName:""}}</span>
							
						</li>
							<li class="info-item info-item-time">
							<span class="item-name">文件个数：</span>
							<span class="item-value">{{this.extractInfo?this.extractInfo.evidenceCount:""}}</span>
						</li>
						<li class="info-item">
							<span class="item-name">创建时间：</span>
							<span class="item-value">{{this.extractInfo?this.extractInfo.createTime:""}}</span>
						</li>
						<li class="info-item">
							<span class="item-name">提取码：</span>
							<span class="item-value" style="padding-left:56px;">{{this.extractInfo?this.extractInfo.extractingCode:""}}</span>
						</li>
						<li class="info-item info-item-remarks" style="display:flex;">
							<span class="item-name" style="width:42px;">备注：</span>
							<el-popover  v-if="this.extractInfo?this.extractInfo.remarks && this.extractInfo.remarks.length>13:false"
									placement="top-start"
									width="200"
									trigger="hover"
									:content="this.extractInfo?this.extractInfo.remarks:''">
									<span class="item-value" slot="reference"  style="padding-left: 27px;cursor: pointer;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: inline-block;width: 200px;" >{{this.extractInfo?this.extractInfo.remarks:''}}</span>
							</el-popover>
							<span v-else class="item-value" slot="reference"  style="padding-left: 27px;cursor: pointer;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: inline-block;width: 200px;" >{{this.extractInfo?this.extractInfo.remarks:''}}</span>

						</li>
					    <li class="info-item ">
							<span class="item-name">失效时间：</span>
							<!-- {{this.extractInfo?this.extractInfo.createTime:""}}<br><span style="color:red;padding-left:71px">已过期</span> -->
							<span class="item-value" style="font-family: MicrosoftYaHei;"></span>
						</li>
					
					</ul>
				</div>
			</div>
</template>
<script>
export default {
	props:["extractInfo"],
	data(){
		return{}
	},
	mounted(){
	}
}
</script>
<style lang="scss">
	.info {
			padding: 17px;
			box-shadow: 0px 5px 10px 0px rgba(177, 177, 178, 0.58);
			border-radius: 4px;
		  background:url("../../assets/images/evidenceExtraction/detail/legalxchain_xi_bg_img.png") #fff ;
		  background-position: center;
		  background-size: contain;
		  background-repeat: no-repeat;
			&-title {
				padding-left: 10px;
				border-left: 3px solid #366efc;
				font-size: 16px;
				font-weight: bold;
				color: #323232;
			}
			&-base {
				padding-left: 13px;
				padding-top: 20px;
				font-size: 14px;
				
			}
			
			&-cont {
				margin-left: 13px;
				padding-bottom: 20px;
				display:flex;
				flex-wrap: wrap;
				.info-item {
					float: left;
					padding-top: 18px;
					width: 460px;
					&:nth-child(even) {
						width: 670px
					}
					.item-name {
					width: 107px;
					font-family: MicrosoftYaHei-Bold;
					font-size: 14px;
					font-weight: bold;
					font-stretch: normal;
					letter-spacing: 0px;
					color: #646464;
					}
				}
			}
			.info-cont-basic{
				.info-item{
				   width: 379px;	
				}
		    }
			&-evidence {
				padding-left: 13px;
				padding-top: 20px;
				font-size: 14px;
			}
			.info-cont-certificate{
				.info-item{
				   width: 379px;	
				}
				.info-item-time{
					width: 376px;
				}
				.info-item-remarks{
					width: 375px;
				}
		    }
		}
</style>